import OnboardingInstallStep from "layouts/OnboardingInstallStep";
import BotTargetingStep from "containers/OnboardingPlaybook/BotTargetingStep";
import OnboardingPlaybookLoadingStep from "layouts/OnboardingPlaybookLoadingStep";
import BotWoohooStep from "containers/OnboardingPlaybook/BotWoohooStep";

export default Object.freeze([
  {
    route: '/install',
    component: OnboardingInstallStep,
  },
  {
    route: '/targeting-url',
    component: BotTargetingStep,
  },
  {
    route: '/loading',
    component: OnboardingPlaybookLoadingStep,
  },
  {
    route: '/woohoo',
    component: BotWoohooStep,
  }
])



// WEBPACK FOOTER //
// ./src/flows/OnboardingFlow/OnboardingBotFlow/routes.js